module.exports = __webpack_public_path__ + "img/stop-iocn.864c5bd1.png";